import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, of, throwError } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { FileObj } from "src/app/model/user/file-obj";
import { ServerType } from "./app-init.service";
import { RestApiService } from "./rest-api.service";
import { UserService } from "./user.service";

export enum FileType {
  PASSPORT,
  COMPANY_REGISTIRATION,
  TAX_REGISTIRATION,
  GENERAL_MENAGER_ID,
  SHAREHOLDER,
}

@Injectable({
  providedIn: "root",
})
export class FileService {
  constructor(
    private restApiService: RestApiService,
    private userService: UserService
  ) {}

  endpoint = "file/";
  FILE_NOT_FOUND = "file_not_found";
  allowedTypes = ["image/jpeg", "image/png", "application/pdf"];

  uploadFile(event, fileType: string) {
    let file = this.buildFile(event);
    console.log("type", file.type);

    if (!this.allowedTypes.includes(file.type)) {
      return throwError({message:"UNALLOWED_TYPE"});
    }
    if (file) {
      return this.finishUploadProcess(file, fileType);
    }

    return throwError(this.FILE_NOT_FOUND);
  }

  buildFile(event) {
    const files: { [key: string]: File } = event.target.files;
    let file: File = null;
    for (let key in files) {
      if (!isNaN(parseInt(key))) {
        file = files[key];
        break;
      }
    }
    return file;
  }

  getFormData(event) {
    let file = this.buildFile(event);
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);

    return { formData, fileName: file.name };
  }

  finishUploadProcess(file: File, fileType: string): Observable<FileObj> {
    const formData: FormData = new FormData();
    formData.append("file", file, file.name);
    return this.upload(formData, fileType);
  }

  upload(file: FormData, fileType: string) {
    let params = new HttpParams();
    params = params.append("fileType", fileType);

    return this.restApiService.post(
      ServerType.USER,
      this.endpoint + "upload",
      file,
      { params }
    );
  }

  download({ s3key, name }: FileObj) {
    const params = new HttpParams().append("s3key", s3key);
    return this.restApiService
      .get(ServerType.USER, this.endpoint + "download", {
        responseType: "blob",
        params: params,
      })
      .pipe(
        map((data) => {
          let binaryData = [];
          binaryData.push(data);
          let blob = new Blob(binaryData, {
            type: MimeType[this.getMimeType(name)],
          });
          const file = new BehaviorSubject<any>(blob);
          let downloadLink = document.createElement("a");
          downloadLink.href = window.URL.createObjectURL(
            new Blob(binaryData, {
              type: MimeType[this.getMimeType(name)],
            })
          );
          downloadLink.setAttribute("download", name);
          return downloadLink;
        })
      );
  }

  getMimeType(fileName: string) {
    return fileName.substring(fileName.lastIndexOf(".") + 1);
  }

  deleteFile(s3Key) {
    return this.restApiService.get(
      ServerType.USER,
      `${this.endpoint}delete-file/${s3Key}`
    );
  }
}
